var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroupe332(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.889,
    height: 16.96,
    viewBox: "0 0 19.889 16.96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1063",
    "data-name": "Group 1063",
    transform: "translate(-62 -7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_655",
    "data-name": "Group 655",
    transform: "translate(62 7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "chart-line-solid",
    d: "M19.267,76.43H2.486V64.622A.621.621,0,0,0,1.865,64H.622A.621.621,0,0,0,0,64.622V77.673a1.243,1.243,0,0,0,1.243,1.243H19.267a.621.621,0,0,0,.622-.622V77.052A.621.621,0,0,0,19.267,76.43Z",
    transform: "translate(0 -61.956)",
    fill: "#1592e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "chart-line-solid-2",
    "data-name": "chart-line-solid",
    d: "M17.414,63.4H13.289a.813.813,0,0,1-.593-1.392l1.132-1.1-2.564-2.492L8.7,60.911a1.141,1.141,0,0,1-1.581,0l-2.4-2.333a.533.533,0,0,1,0-.769l.79-.768a.571.571,0,0,1,.791,0L7.91,58.605l2.564-2.492a1.141,1.141,0,0,1,1.581,0l3.354,3.261,1.132-1.1a.842.842,0,0,1,1.432.576v4.01A.551.551,0,0,1,17.414,63.4Z",
    transform: "translate(-0.807 -49.409)",
    fill: "#1592e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "dollar-sign-solid",
    d: "M3.493,3.857,1.708,3.335a.487.487,0,0,1,.137-.955h1.1a1.009,1.009,0,0,1,.565.174.258.258,0,0,0,.322-.033L4.4,1.958a.268.268,0,0,0-.03-.4,2.337,2.337,0,0,0-1.429-.5V.264A.265.265,0,0,0,2.68,0H2.151a.265.265,0,0,0-.264.264v.793H1.845a1.811,1.811,0,0,0-1.8,1.976,1.892,1.892,0,0,0,1.385,1.6l1.694.5a.487.487,0,0,1-.137.955H1.89a1.009,1.009,0,0,1-.565-.174A.258.258,0,0,0,1,5.941L.427,6.5a.268.268,0,0,0,.03.4,2.337,2.337,0,0,0,1.429.5V8.2a.265.265,0,0,0,.264.264H2.68A.265.265,0,0,0,2.944,8.2V7.4A1.867,1.867,0,0,0,4.691,6.2,1.815,1.815,0,0,0,3.493,3.857Z",
    transform: "translate(12.372)",
    fill: "#1592e6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupe332);
export default __webpack_public_path__ + "static/media/groupe332.8d1172c8c119d095e39603c4490bd501.svg";
export { ForwardRef as ReactComponent };